import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* global Element */
import PropTypes from 'prop-types';
import path from 'path';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import { startCase } from 'lodash';
import Icon from '../../../common/containers/icon';

// Keep styling consistent with Mapbox popovers
const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  popoverBody: {
    padding: '10px'
  },
  row: {
    marginBottom: '5px'
  },
  span: {
    marginLeft: '5px',
    fontStyle: 'normal'
  },
  icon: {
    opacity: '0.25'
  }
};
const buildUrl = _ref => {
  let formID = _ref.formID,
    formTypeIdentifier = _ref.formTypeIdentifier,
    cabinetIdentifier = _ref.cabinetIdentifier;
  if (formID && formTypeIdentifier && cabinetIdentifier) {
    return path.join('/cabinets', cabinetIdentifier, formTypeIdentifier, formID);
  }
  if (formID && formTypeIdentifier) {
    return path.join('/forms', formTypeIdentifier, formID);
  }
  if (formID) {
    return path.join('/directForms', formID);
  }
  return null;
};
const FeaturePopover = _ref2 => {
  let isOpen = _ref2.isOpen,
    _ref2$target = _ref2.target,
    target = _ref2$target === void 0 ? null : _ref2$target,
    _ref2$container = _ref2.container,
    container = _ref2$container === void 0 ? null : _ref2$container,
    _ref2$feature = _ref2.feature,
    feature = _ref2$feature === void 0 ? null : _ref2$feature,
    onClose = _ref2.onClose;
  const history = useHistory();
  const url = useMemo(() => buildUrl(feature || {}), [feature]);
  const displayFields = feature === null || feature === void 0 ? void 0 : feature.displayFields;
  const formTitle = useMemo(() => {
    var _ref3, _ref4, _titleField$value;
    const titleField = Array.isArray(displayFields) ? displayFields.find(f => f.identifier === 'title') : null;
    return (_ref3 = (_ref4 = (_titleField$value = titleField === null || titleField === void 0 ? void 0 : titleField.value) !== null && _titleField$value !== void 0 ? _titleField$value : feature === null || feature === void 0 ? void 0 : feature.title) !== null && _ref4 !== void 0 ? _ref4 : feature === null || feature === void 0 ? void 0 : feature.formTypeIdentifier) !== null && _ref3 !== void 0 ? _ref3 : 'Feature';
  }, [displayFields, feature === null || feature === void 0 ? void 0 : feature.title, feature === null || feature === void 0 ? void 0 : feature.formTypeIdentifier]);
  const bodyFields = useMemo(() => {
    const activityRow = feature !== null && feature !== void 0 && feature.activityType ? [{
      identifier: 'activityType',
      label: 'Activity type',
      value: startCase(feature.activityType)
    }] : [];
    const rest = Array.isArray(displayFields) ? displayFields.filter(f => f.identifier !== 'title') : [];
    return [...activityRow, ...rest];
  }, [feature === null || feature === void 0 ? void 0 : feature.activityType, displayFields]);
  const handleNavigate = () => {
    if (!url) return;
    history.push(url);
    onClose();
  };
  if (!target) return null;
  const containerNode = container != null && container.nodeType === 1 ? container : undefined;
  return /*#__PURE__*/React.createElement(Popover
  // className ensures popover is visible above fullscreened map
  , {
    className: "arcgis-feature-popover",
    target: target,
    container: containerNode,
    placement: "bottom",
    isOpen: isOpen,
    toggle: onClose,
    trigger: "legacy",
    style: {
      width: '320px'
    }
  }, /*#__PURE__*/React.createElement(PopoverHeader, null, /*#__PURE__*/React.createElement("strong", null, formTitle)), /*#__PURE__*/React.createElement(PopoverBody, {
    onClick: handleNavigate,
    style: _objectSpread(_objectSpread({}, styles.popoverBody), {}, {
      cursor: url ? 'pointer' : 'default'
    })
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.container
  }, /*#__PURE__*/React.createElement("div", null, bodyFields.length > 0 ? bodyFields.map(_ref5 => {
    let identifier = _ref5.identifier,
      label = _ref5.label,
      value = _ref5.value;
    return /*#__PURE__*/React.createElement("div", {
      key: identifier || label,
      style: styles.row
    }, /*#__PURE__*/React.createElement("strong", null, "".concat(label, ":")), /*#__PURE__*/React.createElement("span", {
      style: styles.span
    }, String(value !== null && value !== void 0 ? value : '')));
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, (feature === null || feature === void 0 ? void 0 : feature.fromDistance) != null && (feature === null || feature === void 0 ? void 0 : feature.toDistance) != null && /*#__PURE__*/React.createElement("div", {
    style: styles.row
  }, /*#__PURE__*/React.createElement("strong", null, "Station:"), /*#__PURE__*/React.createElement("span", {
    style: styles.span
  }, "".concat(feature.fromDistance, " \u2013 ").concat(feature.toDistance))), (feature === null || feature === void 0 ? void 0 : feature.formID) && /*#__PURE__*/React.createElement("div", {
    style: styles.row
  }, /*#__PURE__*/React.createElement("strong", null, "Form:"), /*#__PURE__*/React.createElement("span", {
    style: styles.span
  }, feature.formID)), /*#__PURE__*/React.createElement("div", {
    style: {
      opacity: 0.75
    }
  }, "Click to open"))), /*#__PURE__*/React.createElement(Icon, {
    glyph: "angle-right",
    style: styles.icon
  }))));
};
FeaturePopover.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  target: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  container: PropTypes.instanceOf(Element),
  feature: PropTypes.shape({
    title: PropTypes.string,
    activityType: PropTypes.string,
    fromDistance: PropTypes.number,
    toDistance: PropTypes.number,
    formID: PropTypes.string,
    formTypeIdentifier: PropTypes.string,
    cabinetIdentifier: PropTypes.string,
    displayFields: PropTypes.arrayOf(PropTypes.shape({
      identifier: PropTypes.string,
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
    }))
  }),
  onClose: PropTypes.func.isRequired
};
export default FeaturePopover;